import { InitialFieldsAlignment } from "@/type/core/dashboard/dashboard.types";
import BasicButton from "@components/core/buttons/BasicButton";
import InfoModal from "@components/core/modals/InfoModal";
import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import AlignmentDropdown from "@components/core/subComponents/InitialFields/AlignmentDropdown";
import { Checkbox, Row } from "antd";
import { applyFirstInitialFieldsToOthers } from "@/state/transactions/CurrentTransactionEvents";

interface InitialFieldsSectionProps {
  activated: boolean;
  setActivated: (activated: boolean) => void;
  alignment: InitialFieldsAlignment;
  setAlignment: (alignment: InitialFieldsAlignment) => void;
  rank: number;
  numberOfFiles: number;
}

const InitialFieldsSection: FunctionComponent<InitialFieldsSectionProps> = ({
  activated,
  setActivated,
  alignment,
  setAlignment,
  rank,
  numberOfFiles,
}) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  return (
    <Row
      className={`d-flex flex-column ${numberOfFiles > 1 ? "h-250px" : "h-150px"}`}
    >
      <span className="pdf-container-titles">
        {t("signature.positioning.initialFields.title")}
      </span>
      <span>{t("signature.positioning.initialFields.description")}</span>
      <div className="align-items-center custom-checkbox mt-2 mb-2">
        <div onClick={() => setActivated(!activated)}>
          <Checkbox
            id={"initialFieldsActivated" + rank}
            name="initialFieldsActivated"
            className="mr-8 custom-control-input"
            type="checkbox"
            checked={activated}
          />
          <label
            className="cursor-pointer custom-control-label format"
            htmlFor={"applyForAll" + rank}
          >
            {t("signature.positioning.initialFields.checkboxLabel")}
          </label>
        </div>
      </div>
      {activated && (
        <div className="d-flex flex-row align-items-start fixed-width-content">
          <span className="mr-2 pt-8">
            {t("signature.positioning.initialFields.alignment.title")}
          </span>
          <div className="position-relative ml-8 w-150px">
            <AlignmentDropdown
              alignment={alignment}
              handleClick={setAlignment}
              className="position-absolute right-0 w-100 z-1000"
            />
          </div>
        </div>
      )}
      {activated && rank === 1 && numberOfFiles > 1 && (
        <div
          className="d-flex align-items-center mt-16"
          id={"placeOtherInitialFields"}
        >
          <BasicButton
            disabled={isLoading}
            isLoading={isLoading}
            variant="tertiary"
            text={t("signature.positioning.applyFirstToOthers")}
            className="mw-300 mr-4 py-8 px-30 mh-42 font-extra-small"
            onClick={() => {
              setIsLoading(true);
              setTimeout(() => setIsLoading(false), 1000);
              applyFirstInitialFieldsToOthers();
            }}
          />
          <InfoModal value="initialFields" info={true} className="ml-8" />
        </div>
      )}
    </Row>
  );
};

export default InitialFieldsSection;
